import React, { useState } from 'react';
import {
  Dialog, DialogTitle, DialogContent, TextField, Box, Typography,
  Card, CardActionArea, IconButton, Chip,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

export default function PromptPicker({ open, onClose, prompts, onSelect }) {
  const [search, setSearch] = useState('');

  const filtered = prompts.filter(
    (p) =>
      p.title.toLowerCase().includes(search.toLowerCase()) ||
      (p.description || '').toLowerCase().includes(search.toLowerCase()) ||
      (p.category || '').toLowerCase().includes(search.toLowerCase())
  );

  // Group by category
  const grouped = {};
  filtered.forEach((p) => {
    const cat = p.category || 'Overig';
    if (!grouped[cat]) grouped[cat] = [];
    grouped[cat].push(p);
  });

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <Typography variant="h6" fontWeight={600}>Prompt Templates</Typography>
        <IconButton onClick={onClose} size="small"><CloseIcon /></IconButton>
      </DialogTitle>
      <DialogContent>
        <TextField
          fullWidth
          size="small"
          placeholder="Zoek prompts..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          sx={{ mb: 2 }}
          autoFocus
        />
        {Object.entries(grouped).map(([category, items]) => (
          <Box key={category} sx={{ mb: 2 }}>
            <Typography variant="caption" sx={{ color: '#6b7280', fontWeight: 600, textTransform: 'uppercase', letterSpacing: 0.5 }}>
              {category}
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, mt: 0.5 }}>
              {items.map((prompt) => (
                <Card key={prompt.id} variant="outlined" sx={{ borderColor: '#e5e7eb' }}>
                  <CardActionArea
                    onClick={() => { onSelect(prompt); onClose(); }}
                    sx={{ p: 2 }}
                  >
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                      <Typography fontWeight={600} fontSize={14}>{prompt.title}</Typography>
                      {prompt.category && (
                        <Chip label={prompt.category} size="small" sx={{ fontSize: 11, height: 20 }} />
                      )}
                    </Box>
                    {prompt.description && (
                      <Typography fontSize={12} color="text.secondary" sx={{ mt: 0.5 }}>
                        {prompt.description}
                      </Typography>
                    )}
                  </CardActionArea>
                </Card>
              ))}
            </Box>
          </Box>
        ))}
        {filtered.length === 0 && (
          <Typography sx={{ py: 3, textAlign: 'center', color: '#9ca3af', fontSize: 14 }}>
            Geen prompts gevonden
          </Typography>
        )}
      </DialogContent>
    </Dialog>
  );
}
